<!-- <div class="sidebar-sheet">
  <div class="sidebar-header">
    <h4>
      {{slide.details.aiAppDetails.name}}
    </h4>
    <button (click)="hideDetectionResults()">
      <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
        <path id="close-btn"
          d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
          transform="translate(5.82 13.32)" fill="#bbb" />
      </svg>
    </button>
  </div> -->
  <div class="sidebar-content" #slidebarContentResult>
    <div *ngIf='dataLoading' class="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <ng-container *ngIf='!dataLoading'>
      <div class="data-empty m-0" *ngIf="!recordData.length">
        <p>{{ 'general.NoFound' | translate }}</p>
      </div>
      <div class="table-responsive h-100" id="slidebarContentResult"
        *ngIf="recordData && recordData.length">
        <table class="table table-primary wrap-datatable">
          <thead>
            <tr>
              <ng-container *ngFor="let item of tHeader">
                <th *ngIf="item !== 'Object ID'">{{item}}</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr [class.active]="selectedIndex === i || scrollToId === ('#'+record['Object ID'])"
              *ngFor="let record of recordData;let i = index" (click)="zoomToDetection(record,i)"
              [id]="'tr-'+record['Object ID']">
              <ng-container *ngFor="let item of tHeader">
                <td *ngIf="item !== 'Object ID'">
                  <ng-container *ngIf="item == 'Image';else other">
                    <!-- <img [src]="record[item]" alt=""> -->
                  </ng-container>
                  <ng-template #other>
                    {{record[item]}}
                  </ng-template>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
<!-- </div> -->
